import numeral from 'numeral';
import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import { reverse } from 'named-urls';
import { gql } from '@apollo/client';
import { Query } from '@apollo/react-components';
import routes from '@achievable-me/tundra-wizard/routes';
import SpinnerError from '$components/library/SpinnerError';
import { inflateContent } from '@achievable-me/tundra-wizard/contentHelpers';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import MemoryProgressTreemap from '$components/ProductDashboard/MemoryProgressTreemap';
import styles from './styles.scss';

const PRODUCT_MEMORY = gql`
  query ProductMemory($input: ProductInput!) {
    product(input: $input) {
      product {
        uuid
        numReadyMemoryEstimates
        numMemoryEstimates
        productMemory {
          content {
            uuid
            slug
            parentUuid
            position
            name
            memoryScore
            numItems
          }
        }
      }
    }
  }
`;

const header = 'Memory progress';
const subheader = (
  <>
    <MediaQuery maxDeviceWidth={575}>tap on chart</MediaQuery>
    <MediaQuery minDeviceWidth={576}>hover over chart</MediaQuery>
  </>
);

const MemoryProgress = (props) => {
  const { product } = props;
  const { slug: productSlug } = product;

  return (
    <div>
      <DashboardHeader header={header} subheader={subheader} />
      <div className={styles.chart}>
        <Query
          query={PRODUCT_MEMORY}
          variables={{ input: { slug: productSlug } }}
          fetchPolicy="network-only"
        >
          {({ loading, error, data }) => {
            // 20190129JP: This is kinda weird since we don't use the data directly.
            //  This will cause the cache to update, so the data flowing from above should be correct.
            if (loading || error) {
              return <SpinnerError error={error} />;
            }

            const {
              product: {
                product: {
                  numMemoryEstimates,
                  numReadyMemoryEstimates,
                  productMemory: { content },
                },
              },
            } = data;

            const reviewDisabled = numMemoryEstimates === 0;

            const reviewText = reviewDisabled // eslint-disable-line no-nested-ternary
              ? 'Read the content first!'
              : numReadyMemoryEstimates
              ? `Review (${numeral(numReadyMemoryEstimates).format('0,0')} ready)`
              : 'Review';

            const { inflatedContent } = inflateContent({ product, content });

            return (
              <>
                <Link to={reverse(routes.study.review, { productSlug })}>
                  <Button
                    data-aaa="reviewButton"
                    data-product-slug={productSlug}
                    type="primary"
                    ghost
                    disabled={reviewDisabled}
                    className={styles.button}
                  >
                    {reviewText}
                  </Button>
                </Link>
                <MemoryProgressTreemap inflatedContent={inflatedContent} />
              </>
            );
          }}
        </Query>
      </div>
    </div>
  );
};

export default MemoryProgress;
